import React from 'react';
import imageIcon from './../../assets/images/button-icons/image-icon.png';
import noImageIcon from './../../assets/images/button-icons/no-image-icon.png';

export default ({ photos }) => {
  const photoCount = photos ? photos.length : 0;
  const icons = [];
  for (let i = 0; i < Math.min(photoCount, 4); i++) {
    icons.push(<img src={imageIcon} className="card-img m-1" alt="count" key={i} style={{ width: '10px', height: '10px'}} />);
  }
  if (photoCount === 0) {
    icons.push(<img src={noImageIcon} className="card-img" alt="count" key='zeroPhotos' style={{ width: '15px', height: '15px'}}/>);
  }
  const renderEllipse = photoCount > 4 
  if (renderEllipse) {
    icons.push(<span key={photoCount} className="ellipse">...</span>);
  }
  return (
    <div className="d-flex mt-2">
      {icons}
    </div>
  )
}